import React, { useEffect, useRef, useState } from "react";
import Card from "../../../elements/Card";
import Input from "../../../form/Input";
import Textarea from "../../../form/Textarea";
import { useParams } from "react-router-dom";
import useClickOutside from "../../../../hooks/useClickOutside";
import { useTranslation } from "react-i18next";

const ReadOnly = ({ data }) => {
  const { t } = useTranslation();

  return (
    <Card
      title={t("Event Details")}
      bodyClass={"space-y-6"}
      className={" py-4 md:py-8 px-3 md:px-6"}
    >
      <div className="space-y-1">
        <h3 className="font-semibold text-lg">{t("Event Heading")}</h3>
        <div className="text-text-gradient-red font-medium">
          {data?.title || "N/A"}
        </div>
      </div>
      <div className="space-y-1">
        <h3 className="font-semibold text-lg">{t("Overview")}</h3>
        <div className="text-text-gradient-red line-clamp-6 break-words">
          {data?.excerpt || "N/A"}
        </div>
      </div>
    </Card>
  );
};

const EventDetails = ({
  values = {},
  handleChange = () => {},
  formValidate = () => {},
  errors,
  data,
}) => {
  const divRef = useRef(null);
  const { t } = useTranslation();
  const { eventId } = useParams();
  const [readOnly, setReadOnly] = useState(false);

  useClickOutside(divRef, () => {
    if (eventId) {
      setReadOnly(true);
    } else {
      setReadOnly(false);
    }
  });

  useEffect(() => {
    if (eventId) {
      setReadOnly(true);
    }
  }, [eventId]);

  return (
    <div
      ref={divRef}
      onClick={() => {
        if (eventId) {
          setReadOnly(false);
        }
      }}
    >
      {readOnly ? (
        <ReadOnly data={values} />
      ) : (
        <Card
          title={t("Event Details")}
          bodyClass={"space-y-6"}
          className={" py-4 md:py-8 px-3 md:px-6"}
        >
          <div className="relative">
            <Input
              label={t("Event Heading")}
              labelClasses={"!text-lg !text-deep-purple !mb-2"}
              inputPlaceholder={t("Event title")}
              inputClasses={
                "!border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"
              }
              inputName={"title"}
              note={t("Create a Title That Reflects Your Event Purpose")}
              noteClasses={"text-slate-500"}
              value={values?.title}
              onChange={handleChange}
              {...formValidate(errors, "title")}
            />
          </div>
          <div className="relative">
            <Textarea
              label={t("Overview")}
              labelClasses={"!text-lg !text-deep-purple !mb-2"}
              inputPlaceholder={t("Overview details")}
              inputClasses={
                "!border-surface-05 !bg-surface-04 !font-medium !text-deep-purple"
              }
              note={`${values?.excerpt?.length || 0} / 800`}
              noteClasses={"text-slate-500 text-right"}
              onChange={handleChange}
              inputName={"excerpt"}
              inputValue={values?.excerpt}
              {...formValidate(errors, "excerpt")}
            />
          </div>
        </Card>
      )}
    </div>
  );
};

export default EventDetails;
